import { CompanyShowBucket } from "@signalist/shared-types";

import { CompanyRowsPage } from "@/pages/Private/redux/list/list-companies.api";

/**
 * The Companies-tab Show filter (PREC-4400): its buckets in display order and their labels, and a
 * reader for the per-bucket counts the endpoint returns (SQL aggregates, so the value can be a
 * string — coerce before use, web CLAUDE.md §6). Pure, so the order and the count reading are
 * tested without mounting the dropdown.
 */

/** The Show-filter buckets, in the order the mockup lists them. */
export const COMPANY_SHOW_BUCKETS: CompanyShowBucket[] = [
	CompanyShowBucket.NOT_SEARCHED,
	CompanyShowBucket.SEARCHING,
	CompanyShowBucket.PEOPLE_FOUND,
	CompanyShowBucket.NO_PERSON_FOUND,
	CompanyShowBucket.ICP_MISMATCH,
	CompanyShowBucket.BLACKLISTED,
];

/** The label for each bucket, as the mockup writes it. */
export const COMPANY_SHOW_BUCKET_LABEL: Record<CompanyShowBucket, string> = {
	[CompanyShowBucket.NOT_SEARCHED]: "No person searched yet",
	[CompanyShowBucket.SEARCHING]: "Searching",
	[CompanyShowBucket.PEOPLE_FOUND]: "People found",
	[CompanyShowBucket.NO_PERSON_FOUND]: "No person found",
	[CompanyShowBucket.ICP_MISMATCH]: "Didn't fit the ICP filter",
	[CompanyShowBucket.BLACKLISTED]: "Blacklisted",
};

/** The count for one bucket, coerced from the endpoint's (possibly string) aggregate. */
export const companyBucketCount = (
	buckets: CompanyRowsPage["buckets"] | undefined,
	bucket: CompanyShowBucket
): number => Number(buckets?.[bucket] ?? 0) || 0;

/** The total number of company rows across every bucket. */
export const totalCompanyCount = (buckets: CompanyRowsPage["buckets"] | undefined): number =>
	COMPANY_SHOW_BUCKETS.reduce((sum, bucket) => sum + companyBucketCount(buckets, bucket), 0);
